import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";

import { debounce } from "lodash";

import SearchBar from "components/SearchBar";
import { findUnitsFromSP } from "utils";
import { picklistsSelectors } from "store/selectors";


const UnitSearchInput = ({ onChange, value, ...rest }) => {
	const { options: units } = useSelector(picklistsSelectors.units);

	const [ options, setOptions ] = useState(units);
	const [ isFetchingOptions, setIsFetchingOptions ] = useState(false);

	const doSearch = useMemo(() => debounce(
		searchText => {
			if (!!searchText) {
				setIsFetchingOptions(true);

				findUnitsFromSP(searchText)
					.then(options => {
						setOptions(options);
						setIsFetchingOptions(false);
					});
			}
		},
		300,
	), []);

	useEffect(() => {
		return () => doSearch.cancel();
	}, [ doSearch ]);

	const onOpen = () => setOptions(units);

	return (
		<SearchBar
			loading={isFetchingOptions}
			options={options}
			onChange={(e, { value }) => onChange(value)}
			onSearchChange={(e, { searchQuery }) => doSearch(searchQuery)}
			value={value}
			selectOnBlur={false}
			onOpen={onOpen}
			{...rest}
		/>
	);
};

export default UnitSearchInput;
